import { REGISTRATION_RESPONSE } from "../actions/registrationActions";
import { ACCESS_TOKEN_ACQUIRED, LOG_OUT_USER } from "../actions/globalActions";
import { getCurrentTimestamp } from "../util/getCurrentTimestamp";
import { LOGIN_RESPONSE } from "../actions/loginActions";
import { REPLACE_CURRENT_USER } from "../actions/schemaActions";
import initialState from "../state/initialState";
import produce from "immer";

function registrationSuccessfulCurrentUserReduction(state, action) {
  return produce(state, (draft) => {
    const { response } = action;
    const { access_token: accessToken, expires_in: expiresIn, user } = response;
    const timeStamp = getCurrentTimestamp();
    const expiry = timeStamp + expiresIn;

    draft.user = user;
    draft.accessToken = accessToken;
    draft.expiry = expiry;
  });
}

function replaceCurrentUser(state, action) {
  return produce(state, (draft) => {
    draft.user = action.user;
  });
}

function logOutUserReduction() {
  return initialState.currentUser;
}

export default function currentUser(state = {}, action) {
  const mapping = {
    REGISTRATION_RESPONSE: registrationSuccessfulCurrentUserReduction,
    LOGIN_RESPONSE: registrationSuccessfulCurrentUserReduction,
    LOG_OUT_USER: logOutUserReduction,
    REPLACE_CURRENT_USER: replaceCurrentUser,
  };

  return mapping[action.type] ? mapping[action.type](state, action) : state;
}
